/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//CD[image change on option change]
$(function(){
  $('.jsOpt').on('change',function(){
    var $selectedThumb = $('.jsThumb[data-alt="'+$(this).val()+'"]');
    if($selectedThumb.length) {
      $selectedThumb.trigger('click');
    }
  });
});

// cd code
$(document).ready(function(){
  $('.product_random-number').text(Math.floor(Math.random() * 9 + 1));
 
  // manually checkout by Cd 
  $(document).on('click','.cd_checkout',function(){
    window.location.href="https://classichomewaregifts.com.au/checkout";
  })

  
});

$(document).on('click','[data-action="close-sidebar"]',function(e){
  e.preventDefault();
  $('body').removeClass('sidecart-opened');
});

$('.sidebar-wrap').on('click',function(e){
  if(!$(e.target).is('.sidebar-inner') && $('.sidebar-inner').has(e.target).length == 0) $('body').removeClass('sidecart-opened');
});

$(document).on('click',function(e){
  if($('body').hasClass('sidecart-opened')) {
    if(!$(e.target).is('.sidebar-inner') && $('.sidebar-inner').has(e.target).length == 0 && !$(e.target).is('.header__cart-toggle') && $('.header__cart-toggle').has(e.target).length == 0) $('body').removeClass('sidecart-opened');
  }
});

function refreshSideCart() {
  $.getJSON('/cart.js',function(cart){
    $('.header__cart-count').text(cart.item_count);
    $.ajax({
      url: '/cart?view=side-cart',
      dataType: 'html',
      success: function(html){
        $('.sidebar-wrap').html($(html).html())
      }
    });
  });
}

function updateQty(qty,line){
  var $line = $('.sidebar-item[data-index="'+line+'"]');
  $line.addClass('processing');
  $.ajax({
    url: '/cart/change.js',
    type: 'post',
    dataType: 'json',
    data: {
      line: line,
      quantity: qty
    },
    complete: function(){
      refreshSideCart();
    }
  });
}

$(document).on('click','.jsQtyBtn',function(){
  var $qty = $(this).parents('.jsQtyWrap').find('.jsQty');
  var qty = parseInt($qty.val());
  qty = (isNaN(qty))?1:qty;
  if($(this).attr('data-action') == 'minus') {
    if(qty >= 0)qty--;
  } else {
    qty++;
  }
  $qty.val(qty);
  updateQty(qty,$(this).parents('.jsQtyWrap').attr('data-line'));
});

$(document).on('change','.jsQty',function(){
  var qty = parseInt($(this).val());
  qty = (isNaN(qty))?1:qty;
  $(this).val(qty);
  updateQty(qty,$(this).parents('.jsQtyWrap').attr('data-line'));
});

$(document).on('click','.jsItemRemove',function(e){
  e.preventDefault();
  updateQty(0,$(this).attr('data-line'));
});

$(document).on('sideCartRefresh',function(){
  refreshSideCart();
});

$(document).ready(function(){
  var timeId;
  timeId = setInterval(function(){
    if($('#smile-ui-container').length) {
      $('#smile-ui-container').parent('div').css({'position': 'relative','z-index': 9999});
      clearInterval(timeId);
    }
  },100);
  
  var timeIdNotify,elemFound = false;
  timeIdNotify = setInterval(function(){
    if(elemFound) {
      $('.notifyjs-corner').wrapAll("<div class='notify-wrap'>");
      clearInterval(timeIdNotify);
    }
    if($('.notifyjs-corner').length) {
      elemFound = true;
    }
  },400);
});


// CD CODE
if($('.timerCountdownWrap').length){
  setInterval(function time(){
    var day = 0;
    var d = new Date();
    var hours = 24 - d.getHours();
    var min = 60 - d.getMinutes();
    if((day + '').length == 1){
      day = '0' + day;
    }
    if((hours + '').length == 1){
      hours = '0' + hours;
    }
    if((min + '').length == 1){
      min = '0' + min;
    }
    var sec = 60 - d.getSeconds();
    if((sec + '').length == 1){
      sec = '0' + sec;
    }
    jQuery('.timerCountdownWrap').html(' <div class="timerCountdown"><span class="p-days p-time">'+ day +'</span><span class="p-hours p-time">'+ hours +'</span><span class="p-minutes p-time">'+ min +'</span><span class="p-sec p-time">'+ sec +'</span></div>')
  }, 1000);
}

$( window ).on('load', function() {
  $('.timer').css('visibility', 'visible');
});


$(document).ready(function(){
  if($(window).width() <= 640){
    $(window).on('scroll',function() {
      var header_offset_top = 0;
      if($("#shopify-section-header .header").length){
        header_offset_top = $("#shopify-section-header .header").height();
      }
      if($(window).scrollTop() > header_offset_top){
        $('.header').addClass('search_not_sticky');
      }else{
        $('.header').removeClass('search_not_sticky');
      }
    });
  }
});